import { PointFormInterface } from 'common/lineForm.interface';

/*
 * Action Types
 */
export enum PointsListTypes {
  SET_POINTS_LIST = '@pointsList/SET_POINTS_LIST',
}

/*
 * State type
 */
export interface PointsListState {
  readonly pointsList: PointFormInterface[];
  readonly save: boolean;
}
